import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "293",
  "slug": "spot-new-zealand-from-satellite-imagery",
  "title": "How to Recognise New Zealand in Satellite Images",
  "excerpt": "The Southern Alps run along much of the South Island, with broad plains to the east and a wetter, more dissected western side.",
  "date": "2026-04-27",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/new-zealand.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Southern Alps run along much of the South Island, with broad plains to the east and a wetter, more dissected western side. The North Island has a different outline and includes a central volcanic region. Cook Strait separates the two main islands."
    },
    {
      "type": "heading",
      "text": "The Southern Alps and two main islands"
    },
    {
      "type": "paragraph",
      "text": "Compare the eastern Canterbury Plains with the western side of the Southern Alps. Notice how quickly terrain rises from each coast."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Mountain scenery can resemble Chile or parts of Europe. Fjords alone do not establish New Zealand. At regional scale, the island outlines and the position of mountains relative to the coasts are stronger clues."
    }
  ],
  "imageAlt": "New Zealand regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
